import { render, staticRenderFns } from "./workSet.vue?vue&type=template&id=04524210&scoped=true&"
import script from "./workSet.vue?vue&type=script&lang=js&"
export * from "./workSet.vue?vue&type=script&lang=js&"
import style0 from "./workSet.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./workSet.vue?vue&type=style&index=1&id=04524210&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04524210",
  null
  
)

export default component.exports